import { EnvironmentBase } from "@definitiv-packages/angular-dba-library";


export class ProjectEnvironment extends EnvironmentBase {
    public vapidPublicKey: string = "";
}
